import parse from 'html-react-parser';
import React, { PropsWithChildren, useEffect } from 'react';

interface HeaderFooterData {
  head?: string;
  bodyTop?: string;
}

interface HeaderFooterProviderProps {
  headerAndFooterData?: HeaderFooterData;
}

export function HeaderFooterProvider({
  headerAndFooterData,
  children,
}: PropsWithChildren<HeaderFooterProviderProps>) {
  useEffect(() => {
    if (!headerAndFooterData?.head) {
      return;
    }

    const elements = extractAndCreateElements(headerAndFooterData.head);
    elements.forEach((el) => document.head.appendChild(el));

    return () => elements.forEach((el) => el.remove());
  }, [headerAndFooterData?.head]);

  return (
    <>
      {parse(headerAndFooterData?.bodyTop ?? '')}
      {children}
    </>
  );
}
function extractAndCreateElements(htmlString: string): HTMLElement[] {
  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = htmlString;

  return Array.from(tempDiv.children).map((el) => {
    const newEl = document.createElement(el.tagName.toLowerCase());

    // Copy all attributes
    Array.from(el.attributes).forEach((attr) => {
      newEl.setAttribute(attr.name, attr.value);
    });

    // Copy content for script/style tags to ensure execution
    if (el.tagName.toLowerCase() === 'script' || el.tagName.toLowerCase() === 'style') {
      newEl.innerHTML = el.innerHTML;
    }

    return newEl;
  });
}
